import { copy } from 'angular';
import { exec } from './filter-actions.exec';
export var forecast = function (groups, filters) {
    if (groups === void 0) { groups = []; }
    if (filters === void 0) { filters = []; }
    var copiedFilters = [];
    var copiedFilterIndex;
    var copiedFilterOptionIndex;
    var copiedFilter;
    var copiedOption;
    var originallyChecked;
    copy(filters, copiedFilters);
    for (copiedFilterIndex = 0; copiedFilterIndex < copiedFilters.length; copiedFilterIndex++) {
        copiedFilter = copiedFilters[copiedFilterIndex];
        if (copiedFilter.mandatory) {
            continue;
        }
        for (copiedFilterOptionIndex = 0; copiedFilterOptionIndex < copiedFilter.options.length; copiedFilterOptionIndex++) {
            copiedOption = copiedFilter.options[copiedFilterOptionIndex];
            originallyChecked = copiedOption.checked;
            copiedOption.checked = true;
            copiedOption.disabled = exec(groups, copiedFilters).length === 0;
            copiedOption.checked = originallyChecked;
        }
    }
    return copiedFilters;
};
